<template>
  <ion-card class="border-default no-shadow rental-card ion-no-margin" color="light">
    <ion-row class="ba-grey pa-xs border-default">
      <ion-col v-if="invoiceSelected?.Invoice.createdAt" size="6">
        <p class="subtitle grey">{{ t('invoices.issueDate') }}</p>
        <div class="d-flex align-center">
          <ion-icon :icon="calendarClearOutline" color="grey"></ion-icon>
          <p class="padding-list-item">
            {{ formatDateTime(invoiceSelected?.Invoice.createdAt as string, locale, true, true) }}
          </p>
        </div>
      </ion-col>
      <ion-col v-if="invoiceSelected?.Invoice.paidAt" size="6">
        <p class="subtitle grey">{{ t('invoices.paidOn') }}</p>
        <div class="d-flex align-center">
          <ion-icon :icon="calendarClearOutline" color="grey"></ion-icon>
          <p class="padding-list-item">
            {{ formatDateTime(invoiceSelected?.Invoice.paidAt as string, locale, true, true) }}
          </p>
        </div>
      </ion-col>
      <ion-col v-if="invoiceSelected?.Invoice.dueDate" size="6">
        <p class="subtitle grey">{{ t('invoices.paymentDeadline') }}</p>
        <div class="d-flex align-center">
          <ion-icon :icon="calendarClearOutline" color="grey"></ion-icon>
          <p class="padding-list-item">
            {{ formatDateTime(invoiceSelected?.Invoice.dueDate as string, locale, true, true) }}
          </p>
        </div>
      </ion-col>
      <ion-col v-if="invoiceSelected?.Invoice.dueDate" size="6">
        <p class="subtitle grey">{{ t('invoices.status') }}</p>
        <div class="d-flex align-center">
          <TagStatus
            :title="t(`status.${invoiceSelected?.Invoice.status}`)"
            :status="invoiceSelected.Invoice.status"
          />
        </div>
      </ion-col>
    </ion-row>
  </ion-card>
</template>

<script setup lang="ts">
  import { useBillingStore } from '@/stores/billing-store';
  import { formatDateTime } from '@/utils/date-utils';
  import { IonCard, IonCol, IonIcon, IonRow } from '@ionic/vue';
  import { calendarClearOutline } from 'ionicons/icons';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';
  import TagStatus from '../booking/TagStatus.vue';

  const { t, locale } = useI18n();
  const { invoiceSelected } = storeToRefs(useBillingStore());
</script>
